import { render, staticRenderFns } from "./FormGroupFloatLabel.vue?vue&type=template&id=2cd23f58&scoped=true&"
import script from "./FormGroupFloatLabel.vue?vue&type=script&lang=js&"
export * from "./FormGroupFloatLabel.vue?vue&type=script&lang=js&"
import style0 from "./FormGroupFloatLabel.vue?vue&type=style&index=0&id=2cd23f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd23f58",
  null
  
)

export default component.exports